export default function BennesConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('bennes');
}

BennesConfiguration.$inject = ['$translatePartialLoaderProvider'];
